import { render, staticRenderFns } from "./BriefGroup.vue?vue&type=template&id=a6690c68&"
import script from "./BriefGroup.vue?vue&type=script&lang=js&"
export * from "./BriefGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports